// Swaps a product card's main image to the hovered/tapped color swatch.
// Clicking a swatch selects that color's photo as the card's new resting
// image (persists after the mouse leaves); hovering any other swatch still
// previews it, but mouseout returns to the selected image, not always the
// original default, so a click actually sticks instead of flashing back.
// Event-delegated on document so it works for cards rendered anywhere
// (collections, homepage, search) without per-card listeners.
(function () {
  function getImage(swatchGroup) {
    var key = swatchGroup.getAttribute('data-card-swatches');
    return document.querySelector('[data-card-main-image="' + key + '"]');
  }

  function setImage(img, src) {
    if (img && src) img.src = src;
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      var swatch = event.target.closest('.card-swatches__item');
      if (!swatch) return;
      var group = swatch.closest('[data-card-swatches]');
      var img = group && getImage(group);
      setImage(img, swatch.getAttribute('data-swatch-image'));
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var swatch = event.target.closest('.card-swatches__item');
      if (!swatch) return;
      var group = swatch.closest('[data-card-swatches]');
      var img = group && getImage(group);
      if (!img) return;
      var restingSrc = img.dataset.selectedSrc || img.dataset.defaultSrc;
      setImage(img, restingSrc);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.card-swatches__item');
    if (!swatch) return;
    event.preventDefault();
    var group = swatch.closest('[data-card-swatches]');
    if (!group) return;
    var img = getImage(group);
    var src = swatch.getAttribute('data-swatch-image');
    if (img && src) img.dataset.selectedSrc = src;
    setImage(img, src);
    group
      .querySelectorAll('.card-swatches__item')
      .forEach(function (el) { el.classList.remove('is-selected'); });
    swatch.classList.add('is-selected');
  });
})();
